import type { Route } from "./+types/projects";
import Page from "../pages/Projects";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.projects() }; }
export const meta = () => pageMeta({ title: "Projects | Gazar", description: "Things I've built -- from production systems to side projects. Real code, real trade-offs.", path: "/projects", image: OG_IMAGE.projects });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
